import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../Auth/firebase";
import { useNavigate } from "react-router-dom";
import { FaEnvelope } from "react-icons/fa";
import Logo from "../../assets/logoTrans.png";
import MyModal from "../../Modals/MyModal";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      await sendPasswordResetEmail(auth, email);
      setIsModalOpen(true);
    } catch (error) {
      alert(error.message);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    navigate("/login");
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-full max-w-md p-8 bg-white shadow-md rounded-md">
        <img src={Logo} alt="Your Logo" className="w-[350px] mr-2" />
        <div className="flex items-center justify-center mb-4">
          <h2 className="text-2xl font-semibold">Reset Password</h2>
        </div>
        <form onSubmit={handleResetPassword}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-600"
            >
              Email:
            </label>
            <div className="relative">
              <FaEnvelope className="absolute text-gray-500 left-3 top-2" />
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-8 pr-4 py-2 w-full border rounded-md"
              />
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-[#9999ff] text-white p-2 rounded-md hover:bg-[#ff8080] focus:outline-none focus:ring focus:border-blue-300"
          >
            Reset Password
          </button>
        </form>
      </div>
      {isModalOpen && (
        <MyModal
          title="Password Reset Successful"
          message="Password reset email sent successfully. Please check your email."
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default ResetPassword;
